// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd954327","239":"e39fb35b","453":"03346f77","455":"bbea6ccf","557":"c762afac","762":"81502f2c"}[chunkId] + ".chunk.js";
};